import { render, staticRenderFns } from "./ExpenseCategories.vue?vue&type=template&id=2c3376d0&scoped=true&"
import script from "./ExpenseCategories.vue?vue&type=script&lang=js&"
export * from "./ExpenseCategories.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseCategories.vue?vue&type=style&index=0&id=2c3376d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3376d0",
  null
  
)

export default component.exports